import { Link, useLocation } from "react-router-dom";
import { Home, LayoutGrid, Search, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

export function MobileNav() {
  const { count, setDrawerOpen } = useCart();
  const { pathname } = useLocation();
  const items = [
    { icon: Home, label: "Home", to: "/", testid: "bottomnav-home" },
    { icon: LayoutGrid, label: "Shop", to: "/shop", testid: "bottomnav-shop" },
    { icon: Search, label: "Search", to: "/search", testid: "bottomnav-search" },
  ];
  return (
    <nav
      data-testid="mobile-bottom-nav"
      aria-label="Quick actions"
      className="fixed inset-x-0 bottom-0 z-50 glass border-t border-brand-line/70 pb-[env(safe-area-inset-bottom)] md:hidden"
    >
      <div className="grid grid-cols-4">
        {items.map(({ icon: Icon, label, to, testid }) => (
          <Link
            key={to}
            to={to}
            data-testid={testid}
            className={`flex flex-col items-center gap-1 py-2.5 text-[10px] font-medium uppercase tracking-wider transition-colors ${
              pathname === to ? "text-brand-pine" : "text-brand-ink/50"
            }`}
          >
            <Icon className="h-5 w-5" />
            {label}
          </Link>
        ))}
        <button
          data-testid="bottomnav-cart"
          onClick={() => setDrawerOpen(true)}
          className="relative flex flex-col items-center gap-1 py-2.5 text-[10px] font-medium uppercase tracking-wider text-brand-ink/50"
        >
          <ShoppingBag className="h-5 w-5" />
          Cart
          {count > 0 && (
            <span className="absolute right-4 top-1 flex h-4 w-4 items-center justify-center rounded-full bg-brand-gold text-[9px] font-bold text-brand-forest">
              {count}
            </span>
          )}
        </button>
      </div>
    </nav>
  );
}
